import React, {useState} from 'react';
import Link from 'next/link';
import Router, {withRouter} from 'next/router';


const TitleLinks = ({...props}) => {
    const [state, setState] = useState(0);
    
    return (
        <>
            {props.parentLink?.length > 0 && (
                <button
                    className="top-bar-back-button"
                    onClick={() => props.router.push(props.parentLink)}
                >
                    <i className="lni lni-chevron-left icon"/>
                </button>
            )}
            <h1 className="navbar-ciol-title"
                onClick={() => props.router.push(props.parentLink)}
            >
                {props.parent}
            </h1>
            <h2 className="navbar-section-title">
                {props.title}
            </h2>
        </>
    );
};

export default withRouter(TitleLinks);
